<template>
  <div class="dashboard">
    <div class="sidebar">
      <div class="sidebar-header">
        <h2>清一公社家园</h2>
      </div>
      <nav class="sidebar-menu">

        <div v-if="hasTherapyPermissions" class="menu-group">
          <div class="menu-group-header" @click="toggleTherapyMenu">
            <span>理疗预约管理</span>
            <span class="menu-arrow" :class="{ 'expanded': therapyMenuExpanded }">▼</span>
          </div>
          <transition name="submenu">
            <div v-show="therapyMenuExpanded" class="menu-group-items">
              <router-link v-if="permissions.canAccessTherapyOverview" to="/dashboard/therapy-overview" class="submenu-item" active-class="active"><span>理疗概览</span></router-link>
              <router-link v-if="permissions.canAccessTherapistManagement" to="/dashboard/therapists" class="submenu-item" active-class="active"><span>理疗师管理</span></router-link>
              <router-link v-if="permissions.canAccessTherapyActivityManagement" to="/dashboard/therapy-activities" class="submenu-item" active-class="active"><span>理疗活动管理</span></router-link>
              <router-link v-if="permissions.canAccessTherapyActivityManagement" to="/dashboard/therapy-bundles" class="submenu-item" active-class="active"><span>理疗套餐管理</span></router-link>
              <router-link v-if="permissions.canAccessTherapyActivityManagement" to="/dashboard/therapy-bundle-purchases" class="submenu-item" active-class="active"><span>套餐订单管理</span></router-link>
              <router-link v-if="permissions.canAccessTherapyScheduleManagement" to="/dashboard/therapy-schedules" class="submenu-item" active-class="active"><span>排班管理</span></router-link>
              <router-link v-if="permissions.canAccessTherapyBookingManagement" to="/dashboard/therapy-bookings" class="submenu-item" active-class="active"><span>预约管理</span></router-link>
              <router-link v-if="permissions.canAccessTherapyStoreManagement" to="/dashboard/therapy-store" class="submenu-item" active-class="active"><span>门店管理</span></router-link>
              <router-link v-if="permissions.canAccessTherapyReviewManagement" to="/dashboard/therapy-reviews" class="submenu-item" active-class="active"><span>评价管理</span></router-link>
              <router-link v-if="permissions.canAccessCustomerTypeManagement" to="/dashboard/customer-types" class="submenu-item" active-class="active"><span>客户类型管理</span></router-link>
              <router-link v-if="permissions.canAccessTherapyCustomerManagement" to="/dashboard/therapy-customers" class="submenu-item" active-class="active"><span>理疗客户管理</span></router-link>
              <router-link v-if="permissions.canAccessTherapyH5VirtualPhoneManagement" to="/dashboard/therapy-h5-virtual-phones" class="submenu-item" active-class="active"><span>H5虚拟手机号管理</span></router-link>
            </div>
          </transition>
        </div>
        
        <!-- 课程管理折叠菜单 -->
        <div v-if="hasCoursePermissions" class="menu-group">
          <div class="menu-group-header" @click="toggleCourseMenu">
            <span>课程管理</span>
            <span class="menu-arrow" :class="{ 'expanded': courseMenuExpanded }">▼</span>
          </div>
          <transition name="submenu">
            <div v-show="courseMenuExpanded" class="menu-group-items">
              <router-link v-if="permissions.canAccessCourseManagement" to="/dashboard/courses" class="submenu-item" active-class="active">
                <span>课程管理</span>
              </router-link>
              <router-link v-if="permissions.canAccessEnrollmentApproval" to="/dashboard/enrollments" class="submenu-item" active-class="active">
                <span>报名审批</span>
              </router-link>
              <router-link v-if="permissions.canAccessEnrollmentApproval" to="/dashboard/payment-records" class="submenu-item" active-class="active">
                <span>转账记录审核</span>
              </router-link>
              <router-link v-if="permissions.canAccessStudentList" to="/dashboard/students" class="submenu-item" active-class="active">
                <span>学员清单</span>
              </router-link>
              <router-link v-if="permissions.canAccessStudentList" to="/dashboard/students-potential" class="submenu-item" active-class="active">
                <span>潜在学员清单</span>
              </router-link>
              <router-link v-if="permissions.canAccessStudentHistoryImport" to="/dashboard/students-import-history" class="submenu-item" active-class="active">
                <span>历史学员导入</span>
              </router-link>
              <router-link v-if="permissions.canAccessBlacklistManagement" to="/dashboard/blacklist" class="submenu-item" active-class="active">
                <span>黑名单管理</span>
              </router-link>
              <router-link v-if="permissions.canAccessHistoryLog" to="/dashboard/history" class="submenu-item" active-class="active">
                <span>历史日志</span>
              </router-link>
              <router-link v-if="permissions.canAccessCourseManagement" to="/dashboard/tags" class="submenu-item" active-class="active">
                <span>标签管理</span>
              </router-link>
            </div>
          </transition>
        </div>
        
        <router-link v-if="isAdmin" to="/dashboard/forms" class="menu-item" active-class="active">
          <span>表单管理</span>
        </router-link>
        <router-link v-if="permissions.canAccessUserManagement" to="/dashboard/users" class="menu-item" active-class="active">
          <span>用户管理</span>
        </router-link>
        <router-link v-if="permissions.canAccessRolePermissions" to="/dashboard/role-permissions" class="menu-item" active-class="active">
          <span>角色权限管理</span>
        </router-link>
        <router-link v-if="permissions.canAccessRecordingAnalysis" to="/dashboard/recording-analysis" class="menu-item" active-class="active">
          <span>录音解析管理</span>
        </router-link>
        <router-link to="/dashboard/profile" class="menu-item" active-class="active">
          <span>个人资料</span>
        </router-link>
      </nav>
      <div class="sidebar-footer">
        <button class="logout-button" @click="logout">登出</button>
      </div>
    </div>
    <div class="main-content">
      <main class="dashboard-content">
        <router-view></router-view>
      </main>
    </div>
  </div>
</template>

<script>
import { authService } from '../services/authService'

export default {
  name: 'AdminDashboard',
  data() {
    return {
      currentUser: null,
      courseMenuExpanded: true,
      therapyMenuExpanded: true,
      permissions: {
        canAccessCourseManagement: false,
        canAccessEnrollmentApproval: false,
        canAccessStudentList: false,
        canAccessStudentHistoryImport: false,
        canAccessHistoryLog: false,
        canAccessUserManagement: false,
        canAccessBlacklistManagement: false,
        canAccessRolePermissions: false,
        canAccessRecordingAnalysis: false,
        canAccessTherapistManagement: false,
        canAccessTherapyActivityManagement: false,
        canAccessTherapyScheduleManagement: false,
        canAccessTherapyBookingManagement: false,
        canAccessTherapyStoreManagement: false,
        canAccessTherapyReviewManagement: false,
        canAccessCustomerTypeManagement: false,
        canAccessTherapyCustomerManagement: false,
        canAccessTherapyH5VirtualPhoneManagement: false,
        canAccessTherapyOverview: false
      }
    }
  },
  computed: {
    hasCoursePermissions() {
      return this.permissions.canAccessCourseManagement ||
             this.permissions.canAccessEnrollmentApproval ||
             this.permissions.canAccessStudentList ||
             this.permissions.canAccessStudentHistoryImport ||
             this.permissions.canAccessBlacklistManagement ||
             this.permissions.canAccessHistoryLog
    },
    hasTherapyPermissions() {
      return this.permissions.canAccessTherapyOverview ||
        this.permissions.canAccessTherapistManagement ||
        this.permissions.canAccessTherapyActivityManagement ||
        this.permissions.canAccessTherapyScheduleManagement ||
        this.permissions.canAccessTherapyBookingManagement ||
        this.permissions.canAccessTherapyStoreManagement ||
        this.permissions.canAccessTherapyReviewManagement ||
        this.permissions.canAccessCustomerTypeManagement ||
        this.permissions.canAccessTherapyCustomerManagement ||
        this.permissions.canAccessTherapyH5VirtualPhoneManagement
    },
    isAdmin() {
      return authService.isAdmin()
    },
    isSuperAdmin() {
      const user = authService.getCurrentUser()
      return user && (user.role === '平台管理员' || user.role === 'SUPER_ADMIN')
    }
  },
  mounted() {
    this.loadCurrentUser()
    this.loadPermissions()
    this.checkActiveCourseRoute()
  },
  watch: {
    '$route'() {
      this.checkActiveCourseRoute()
    }
  },
  methods: {
    loadCurrentUser() {
      this.currentUser = authService.getCurrentUser()
      if (!this.currentUser) {
        this.$router.push('/')
      }
    },
    
    async loadPermissions() {
      try {
        const { permissionService } = await import('@/services/permissionService')
        
        // 并行检查所有权限
        const [courseManagement, enrollmentApproval, studentList, studentHistoryImport, historyLog, userManagement, blacklistManagement, rolePermissions, recordingAnalysis, therapistManagement, therapyActivityManagement, therapyScheduleManagement, therapyBookingManagement, therapyStoreManagement, therapyReviewManagement, customerTypeManagement, therapyCustomerManagement, therapyH5VirtualPhoneManagement, therapyOverview] = await Promise.all([
          permissionService.canAccessCourseManagement(),
          permissionService.canAccessEnrollmentApproval(),
          permissionService.canAccessStudentList(),
          permissionService.canAccessStudentHistoryImport(),
          permissionService.canAccessHistoryLog(),
          permissionService.canAccessUserManagement(),
          permissionService.canAccessBlacklistManagement(),
          permissionService.canAccessRolePermissions(),
          permissionService.canAccessRecordingAnalysis(),
          permissionService.canAccessTherapistManagement(),
          permissionService.canAccessTherapyActivityManagement(),
          permissionService.canAccessTherapyScheduleManagement(),
          permissionService.canAccessTherapyBookingManagement(),
          permissionService.canAccessTherapyStoreManagement(),
          permissionService.canAccessTherapyReviewManagement(),
          permissionService.canAccessCustomerTypeManagement(),
          permissionService.canAccessTherapyCustomerManagement(),
          permissionService.canAccessTherapyH5VirtualPhoneManagement(),
          permissionService.canAccessTherapyOverview()
        ])
        
        this.permissions = {
          canAccessCourseManagement: courseManagement,
          canAccessEnrollmentApproval: enrollmentApproval,
          canAccessStudentList: studentList,
          canAccessStudentHistoryImport: studentHistoryImport,
          canAccessHistoryLog: historyLog,
          canAccessUserManagement: userManagement,
          canAccessBlacklistManagement: blacklistManagement,
          canAccessRolePermissions: rolePermissions,
          canAccessRecordingAnalysis: recordingAnalysis,
          canAccessTherapistManagement: therapistManagement,
          canAccessTherapyActivityManagement: therapyActivityManagement,
          canAccessTherapyScheduleManagement: therapyScheduleManagement,
          canAccessTherapyBookingManagement: therapyBookingManagement,
          canAccessTherapyStoreManagement: therapyStoreManagement,
          canAccessTherapyReviewManagement: therapyReviewManagement,
          canAccessCustomerTypeManagement: customerTypeManagement,
          canAccessTherapyCustomerManagement: therapyCustomerManagement,
          canAccessTherapyH5VirtualPhoneManagement: therapyH5VirtualPhoneManagement,
          canAccessTherapyOverview: therapyOverview
        }
        
      } catch (error) {
        console.error('权限检查失败:', error)
        // 如果权限检查失败，默认显示所有菜单（保持原有行为）
        this.permissions = {
          canAccessCourseManagement: this.isAdmin || authService.isCourseAdmin(),
          canAccessEnrollmentApproval: this.isAdmin || authService.isCourseAdmin(),
          canAccessStudentList: this.isAdmin || authService.isCourseAdmin(),
          canAccessStudentHistoryImport: this.isAdmin,
          canAccessHistoryLog: this.isAdmin || authService.isCourseAdmin(),
          canAccessUserManagement: this.isAdmin,
          canAccessBlacklistManagement: this.isAdmin || authService.isCourseAdmin(),
          canAccessRolePermissions: this.isAdmin,
          canAccessRecordingAnalysis: this.isAdmin,
          canAccessTherapistManagement: this.isAdmin || authService.isTherapyAdmin(),
          canAccessTherapyActivityManagement: this.isAdmin || authService.isTherapyAdmin(),
          canAccessTherapyScheduleManagement: this.isAdmin || authService.isTherapyAdmin(),
          canAccessTherapyBookingManagement: this.isAdmin || authService.isTherapyAdmin(),
          canAccessTherapyStoreManagement: this.isAdmin || authService.isTherapyAdmin(),
          canAccessTherapyReviewManagement: this.isAdmin || authService.isTherapyAdmin(),
          canAccessCustomerTypeManagement: this.isAdmin || authService.isTherapyAdmin(),
          canAccessTherapyCustomerManagement: this.isAdmin || authService.isTherapyAdmin(),
          canAccessTherapyH5VirtualPhoneManagement: this.isAdmin || authService.isTherapyAdmin(),
          canAccessTherapyOverview: this.isAdmin || authService.isTherapyAdmin()
        }
      }
    },
    
    // 权限更新方法，供其他组件调用
    async refreshPermissions() {
      await this.loadPermissions()
    },
    
    logout() {
      authService.logout()
      this.$router.push('/')
    },
    toggleCourseMenu() {
      this.courseMenuExpanded = !this.courseMenuExpanded
    },
    toggleTherapyMenu() {
      this.therapyMenuExpanded = !this.therapyMenuExpanded
    },
    checkActiveCourseRoute() {
      const route = this.$route.path
      const courseRoutes = ['/dashboard/courses', '/dashboard/enrollments', '/dashboard/payment-records', '/dashboard/students', '/dashboard/students-potential', '/dashboard/students-import-history', '/dashboard/blacklist', '/dashboard/history', '/dashboard/tags']
      if (courseRoutes.includes(route)) {
        this.courseMenuExpanded = true
      }
      const therapyRoutes = ['/dashboard/therapy-overview', '/dashboard/therapists', '/dashboard/therapy-activities', '/dashboard/therapy-bundles', '/dashboard/therapy-bundle-purchases', '/dashboard/therapy-schedules', '/dashboard/therapy-bookings', '/dashboard/therapy-store', '/dashboard/therapy-reviews', '/dashboard/customer-types', '/dashboard/therapy-customers', '/dashboard/therapy-h5-virtual-phones']
      if (therapyRoutes.includes(route)) {
        this.therapyMenuExpanded = true
      }
    }
  }
}
</script>

<style scoped>
.dashboard {
  display: flex;
  height: 100vh;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.sidebar {
  width: 280px;
  background: linear-gradient(145deg, #2c3e50 0%, #34495e 100%);
  color: white;
  display: flex;
  flex-direction: column;
  box-shadow: 4px 0 20px rgba(0,0,0,0.1);
  position: relative;
  overflow: hidden;
}

.sidebar::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(255,255,255,0.1) 0%, transparent 100%);
  pointer-events: none;
}

.sidebar-header {
  padding: 2rem 1.5rem;
  border-bottom: 1px solid rgba(255,255,255,0.1);
  position: relative;
  z-index: 1;
}

.sidebar-header h2 {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  white-space: nowrap;
  background: linear-gradient(45deg, #fff, #e8f4fd);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.sidebar-menu {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 1rem 0;
  position: relative;
  z-index: 1;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 1rem 1.5rem;
  color: rgba(255,255,255,0.8);
  text-decoration: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  font-weight: 500;
  border-left: 4px solid transparent;
  justify-content: center;
  text-align: center;
}

.menu-item span {
  font-size: 0.9rem;
  font-weight: 600;
  text-align: center;
  width: 100%;
  display: block;
  line-height: 1.2;
}

.menu-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(180deg, #3498db, #2ecc71);
  transform: scaleY(0);
  transition: transform 0.3s ease;
}

.menu-item:hover {
  background: linear-gradient(90deg, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0.05) 100%);
  color: white;
  transform: translateX(8px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.menu-item:hover::before {
  transform: scaleY(1);
}

.menu-item.active {
  background: linear-gradient(90deg, rgba(52, 152, 219, 0.3) 0%, rgba(46, 204, 113, 0.1) 100%);
  color: white;
  border-left-color: #3498db;
  box-shadow: inset 0 0 20px rgba(52, 152, 219, 0.2);
}

.menu-item.active::before {
  transform: scaleY(1);
}

.menu-group {
  margin: 0.5rem 0;
}

.menu-group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  color: rgba(255,255,255,0.9);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 600;
  border-left: 4px solid transparent;
  user-select: none;
}

.menu-group-header:hover {
  background: linear-gradient(90deg, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0.05) 100%);
  color: white;
}

.menu-group-header span:first-child {
  font-size: 0.9rem;
  flex: 1;
}

.menu-arrow {
  font-size: 0.7rem;
  transition: transform 0.3s ease;
  color: rgba(255,255,255,0.7);
}

.menu-arrow.expanded {
  transform: rotate(180deg);
}

.menu-group-items {
  overflow: hidden;
  background: rgba(0,0,0,0.1);
}

.submenu-item {
  display: flex;
  align-items: center;
  padding: 0.75rem 1.5rem 0.75rem 3rem;
  color: rgba(255,255,255,0.7);
  text-decoration: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  font-weight: 500;
  border-left: 4px solid transparent;
}

.submenu-item span {
  font-size: 0.85rem;
  width: 100%;
  display: block;
}

.submenu-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(180deg, #3498db, #2ecc71);
  transform: scaleY(0);
  transition: transform 0.3s ease;
}

.submenu-item:hover {
  background: linear-gradient(90deg, rgba(255,255,255,0.12) 0%, rgba(255,255,255,0.05) 100%);
  color: white;
  padding-left: 3.5rem;
}

.submenu-item:hover::before {
  transform: scaleY(1);
}

.submenu-item.active {
  background: linear-gradient(90deg, rgba(52, 152, 219, 0.25) 0%, rgba(46, 204, 113, 0.1) 100%);
  color: white;
  border-left-color: #3498db;
}

.submenu-item.active::before {
  transform: scaleY(1);
}

.submenu-enter-active,
.submenu-leave-active {
  transition: all 0.3s ease;
  max-height: 500px;
}

.submenu-enter-from,
.submenu-leave-to {
  max-height: 0;
  opacity: 0;
}

.sidebar-footer {
  padding: 1.5rem;
  border-top: 1px solid rgba(255,255,255,0.1);
  position: relative;
  z-index: 1;
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.7) 100%);
  backdrop-filter: blur(10px);
  border-radius: 20px 0 0 20px;
  margin: 20px 20px 20px 0;
  box-shadow: 0 8px 32px rgba(0,0,0,0.1);
}

.content-header {
  background: linear-gradient(135deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.6) 100%);
  padding: 2rem;
  border-bottom: 1px solid rgba(0,0,0,0.05);
  backdrop-filter: blur(10px);
}

.content-header h1 {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  background: linear-gradient(135deg, #2c3e50, #3498db);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.dashboard-content {
  flex: 1;
  padding: 2rem;
  overflow-y: auto;
  background: transparent;
}

.logout-button {
  width: 100%;
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
  color: white;
  border: none;
  padding: 0.75rem 1rem;
  border-radius: 12px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(231, 76, 60, 0.3);
}

.logout-button:hover {
  background: linear-gradient(135deg, #c0392b 0%, #a93226 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(231, 76, 60, 0.4);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .dashboard {
    flex-direction: column;
  }
  
  .sidebar {
    width: 100%;
    height: auto;
  }
  
  .main-content {
    margin: 0;
    border-radius: 0;
  }
  
  .dashboard-content {
    padding: 1rem;
  }
}
</style>